export default "__VITE_ASSET__mGRAIWla__"